import { useMemo } from 'react';

/**
 * Determines if the airdrop pre claim process is active based on environment variable
 */
export const useIsPreClaimActive = (): boolean => {
  return useMemo(() => process.env.NEXT_PUBLIC_PRE_CLAIM_ACTIVE === 'true', []);
};
